import { ObjectValues } from 'types';

export const SORTING_ORDER = {
  A_TO_Z: 'a_to_z',
  Z_TO_A: 'z_to_a',
} as const;

export type SortingOrder = ObjectValues<typeof SORTING_ORDER>;

export type SortingField = {
  name: string;
  order: SortingOrder;
};

export type SortByForm = {
  sortBy: SortingField[];
};

export type SortingDirectionValues = Record<
  string,
  Record<SortingOrder, string>
>;

export type SortingDirectionValue = Record<SortingOrder, string>;

export const ASCENDING_DESCENDING_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'ascending',
  [SORTING_ORDER.Z_TO_A]: 'descending',
};

export const INITIAL_ADVANCED_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'initialFirst',
  [SORTING_ORDER.Z_TO_A]: 'advancedFirst',
};

export const EARLIEST_LATEST_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'earliestFirst',
  [SORTING_ORDER.Z_TO_A]: 'latestFirst',
};

export const LOWEST_HIGHEST_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'lowestFirst',
  [SORTING_ORDER.Z_TO_A]: 'highestFirst',
};

export const LOWEST_HIGHEST_RANGE_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'lowestToHighest',
  [SORTING_ORDER.Z_TO_A]: 'highestToLowest',
};

export const OLDEST_NEWEST_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'oldestToNewest',
  [SORTING_ORDER.Z_TO_A]: 'newestToOldest',
};

export const COLD_HOT_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'coldFirst',
  [SORTING_ORDER.Z_TO_A]: 'hotFirst',
};

export const NO_LISTING_WITH_LISTING_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'noListingFirst',
  [SORTING_ORDER.Z_TO_A]: 'withListingFirst',
};

export const LEAST_MOST_PROGRESSED_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'leastProgressedFirst',
  [SORTING_ORDER.Z_TO_A]: 'mostProgressedFirst',
};

export const NOT_ACCEPTED_ACCEPTED_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'notAcceptedFirst',
  [SORTING_ORDER.Z_TO_A]: 'acceptedFirst',
};

export const WITHOUT_WITH_IM_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'withoutImFirst',
  [SORTING_ORDER.Z_TO_A]: 'withImFirst',
};

export const WITHOUT_WITH_NDA_COPY = {
  [SORTING_ORDER.A_TO_Z]: 'withoutNdaFirst',
  [SORTING_ORDER.Z_TO_A]: 'withNdaFirst',
};
